export const translations = {
    required: "não pode ficar em branco",
    invalid: "não é válido"
};
